function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2 2v20h20V2H2zm19 19H3V3h18v18zm-10.557-7.614h1.61c2.199 0 3.376-1.555 3.376-3.222 0-1.82-1.177-3.109-3.376-3.109H9V17h1.443v-3.614zm0-5.113h1.373c1.204 0 2.129.49 2.129 1.891 0 1.289-.925 2.018-2.129 2.018h-1.373V8.273z",
  fill: "#00708d"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.25,
  fill: "none",
  d: "M0 0h24v24H0z"
});

function SvgParking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    className: "icon"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMjQuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0icGFya2luZy1sYXllciIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IgoJIHk9IjBweCIgdmlld0JveD0iMCAwIDI0IDI0IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyNCAyNDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8ZyBpZD0icGFya2luZyI+Cgk8cGF0aCBzdHlsZT0iZmlsbDojMDA3MDhEOyIgZD0iTTIsMnYyMGgyMFYySDJ6IE0yMSwyMUgzVjNoMThWMjF6IE0xMC40NDMsMTMuMzg2aDEuNjFjMi4xOTksMCwzLjM3Ni0xLjU1NSwzLjM3Ni0zLjIyMgoJCWMwLTEuODItMS4xNzctMy4xMDktMy4zNzYtMy4xMDlIOVYxN2gxLjQ0M1YxMy4zODZ6IE0xMC40NDMsOC4yNzNoMS4zNzNjMS4yMDQsMCwyLjEyOSwwLjQ5LDIuMTI5LDEuODkxCgkJYzAsMS4yODktMC45MjUsMi4wMTgtMi4xMjksMi4wMThoLTEuMzczVjguMjczeiIvPgoJPHJlY3Qgc3R5bGU9Im9wYWNpdHk6MC4yNTtmaWxsOm5vbmU7IiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz4KPC9nPgo8L3N2Zz4K";
export { SvgParking as ReactComponent };